// ** Third Party Components
import { useTranslation } from "react-i18next";
// ** Reactstrap Imports
import { handleLang } from "@store/layout/layout";
import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";

const IntlTuneIn = () => {
  const { i18n, t } = useTranslation();
  const dispatch = useDispatch();
  const setLang = (type) => {
    dispatch(handleLang(type));
  };
  var item = window.localStorage.getItem("lang");
  const item1 = item ? item.substring(1, item.length - 1) : "en";
  const handleLangUpdate = (e, lang) => {
    e.preventDefault();
    i18n.changeLanguage(item1);
    setLang(lang);
  };
  const [language_, setLanguage_] = useState();
  useEffect(() => {
    i18n.changeLanguage(item1);
    setLanguage_(item1);
  }, [item1]);

  return (
    <div
      className="modal fade lang_ms_banner"
      id="changeLangTuneIn"
      tabIndex="-1"
      aria-labelledby="changeLangTuneInLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <button type="button" className="close" data-bs-dismiss="modal">
            ×
          </button>
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12 col-12">
              <div className="m24_language_box ms_cover">
                <h1>{t("Language Selection")}</h1>
                <p>{t("Please select the language.")}</p>
              </div>
              <div className="lang_list_checkbox">
                <ul>
                  <li>
                    <p className="music_field_box">
                      <input
                        type="radio"
                        id="c1"
                        name="cb"
                        checked={language_ === "en"}
                        onChange={() => {
                          setLanguage_("en");
                        }}
                      />
                      <label htmlFor="c1">
                        {t("English")}
                        <span>en</span>
                      </label>
                    </p>
                  </li>
                  <li>
                    <p className="music_field_box">
                      <input
                        type="radio"
                        id="c2"
                        name="cb"
                        checked={language_ === "fr"}
                        onChange={() => {
                          setLanguage_("fr");
                        }}
                      />
                      <label htmlFor="c2">
                        {t("Français")} <span>fr</span>
                      </label>
                    </p>
                  </li>

                  <li>
                    <p className="music_field_box">
                      <input
                        type="radio"
                        id="c3"
                        name="cb"
                        checked={language_ === "ar"}
                        onChange={() => {
                          setLanguage_("ar");
                        }}
                      />
                      <label htmlFor="c3">
                        {t("Arabic")} <span>ar</span>
                      </label>
                    </p>
                  </li>
                </ul>
              </div>
              <div className="lang_apply_btn_wrapper ms_cover">
                <div
                  className="lang_apply_btn"
                  onClick={(e) => handleLangUpdate(e, language_)}
                >
                  <a>{t("apply")}</a>
                </div>
                <div
                  className="cancel_wrapper"
                  onClick={() => {
                    setLanguage_(item1);
                  }}
                >
                  <a data-dismiss="modal">{t("Cancel")}</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IntlTuneIn;
